<div class="modal-header votum-modal__header">
  <div class="votum-modal__title-section">
    <div class="d-flex align-items-center gap-2 mb-1">
      <h4 class="modal-title votum-modal__title mb-0">
        <i class="bi bi-chat-quote-fill votum-modal__icon"></i>
        Votum
      </h4>
      @if (isVotumEditMode) {
      <span class="votum-modal__edit-indicator">
        <i class="bi bi-pencil-square"></i>
        Bearbeitung
      </span>
      }
    </div>
    <p class="votum-modal__subtitle">
      {{data.request.display_name || data.request.expand?.case?.name || $any(data.request)?.case?.name || 'Gutachten'}}
    </p>
  </div>

  <div class="votum-modal__actions">
    @if (!isVotumEditMode && authService.isAdmin()) {
    <button class="btn btn-sm btn-outline-primary votum-modal__edit-btn" (click)="enableVotumEdit()">
      <i class="bi bi-pencil-fill"></i>
      <span class="d-none d-sm-inline">Bearbeiten</span>
    </button>
    }
    @if (isVotumEditMode) {
    <div class="votum-modal__edit-actions">
      <button class="btn btn-sm btn-success votum-modal__save-btn" (click)="saveVotumEdit()">
        <i class="bi bi-check-lg"></i>
        <span class="d-none d-sm-inline">Speichern</span>
      </button>
      <button class="btn btn-sm btn-outline-secondary votum-modal__cancel-btn" (click)="cancelVotumEdit()">
        <i class="bi bi-x-lg"></i>
        <span class="d-none d-sm-inline">Abbrechen</span>
      </button>
    </div>
    }
  </div>

  <button type="button" class="btn-close votum-modal__close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body votum-modal__body">
  <!-- Tab Navigation -->
  <nav class="votum-modal__nav" aria-label="Votum sections">
    <ul class="nav nav-tabs votum-modal__tabs">
      @for (tab of filteredTabs; track tab.value) {
      <li class="nav-item">
        <button class="nav-link votum-modal__tab" [class.active]="activeTabValue === tab.value" (click)="switchTab(tab)"
          type="button">
          {{tab.name}}
        </button>
      </li>
      }
    </ul>
  </nav>

  <!-- Content Area -->
  <div class="votum-modal__content">
    @for (tab of filteredTabs; track tab.value) {
    @if (activeTabValue === tab.value) {
    <div class="votum-modal__tab-content">
      @if (isVotumEditMode) {
      <textarea class="form-control votum-modal__textarea" [rows]="12" [style.font-size.px]="data.txtSizeValL"
        [(ngModel)]="editedVotum[tab.value]" [placeholder]="'Gib hier den Inhalt für ' + tab.name + ' ein...'">
            </textarea>
      } @else {
      <div class="votum-modal__display-content" [style.font-size.px]="data.txtSizeValL">
        @if (tab.value === 'note' && zusatzInfo; as zusatz) {
        <!-- Umschalter Note mit/ohne Zusatzpunkte (nur wenn Bonus/Malus vergeben wurde) -->
        <div class="btn-group btn-group-sm mb-3" role="group" aria-label="Notenansicht">
          <button type="button" class="btn"
            [class.btn-primary]="zusatzView === 'mit'" [class.btn-outline-primary]="zusatzView !== 'mit'"
            (click)="zusatzView = 'mit'">Mit Zusatzpunkten</button>
          <button type="button" class="btn"
            [class.btn-primary]="zusatzView === 'ohne'" [class.btn-outline-primary]="zusatzView !== 'ohne'"
            (click)="zusatzView = 'ohne'">Nur Bewertungsschablone</button>
        </div>
        <div>{{ zusatzView === 'mit' ? zusatz.mitText : zusatz.ohneText }}</div>
        <div class="small text-muted mt-3">
          <i class="bi bi-plus-slash-minus me-1"></i>
          Zusatzpunkte: +{{ zusatz.bonus }} Bonus / −{{ zusatz.malus }} Malus
        </div>
        } @else {
        <div [innerHTML]="getFormattedVotumContent(tab.value)"></div>
        }
      </div>
      }
    </div>
    }
    }
  </div>
</div>

<div class="modal-footer votum-modal__footer">
  <!-- NPS Survey Section -->
  @if (showNPSSurvey && !hasSubmittedNPS) {
  <div class="nps-survey-section w-100 mb-3">
    <div class="nps-survey-header">
      <h6 class="mb-2">
        <i class="bi bi-star-fill me-2"></i>
        Wie hilfreich war die Korrektur?
      </h6>
      <p class="text-muted small mb-3">Dein Feedback hilft uns, die Qualität zu verbessern.</p>
    </div>

    <!-- Star Rating -->
    <div class="nps-stars mb-3">
      @for (star of [1, 2, 3, 4, 5]; track star) {
      <button type="button" class="nps-star-btn" [class.selected]="star <= selectedRating" (click)="selectRating(star)"
        [attr.aria-label]="'Bewertung ' + star + ' von 5'">
        <i class="bi" [class.bi-star-fill]="star <= selectedRating" [class.bi-star]="star > selectedRating"></i>
      </button>
      }
    </div>

    @if (selectedRating > 0) {
    <p class="nps-rating-label text-center mb-3">
      <strong>{{ getRatingLabel(selectedRating) }}</strong>
    </p>

    <!-- Optional Comment -->
    <div class="nps-comment mb-3">
      <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="npsComment"
        [placeholder]="getCommentPlaceholder()" [disabled]="isSubmittingNPS"></textarea>
    </div>

    <!-- Submit/Skip Buttons -->
    <div class="nps-actions d-flex gap-2 justify-content-end">
      <button type="button" class="btn btn-sm btn-link text-muted" (click)="skipNPSSurvey()"
        [disabled]="isSubmittingNPS">
        Überspringen
      </button>
      <button type="button" class="btn btn-sm btn-success" (click)="submitNPSRating()" [disabled]="isSubmittingNPS">
        @if (isSubmittingNPS) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        Wird gesendet...
        } @else {
        <i class="bi bi-send-fill me-1"></i>
        Bewertung abgeben
        }
      </button>
    </div>
    }
  </div>
  }

  <!-- Regular Footer Actions -->
  <div class="votum-modal__footer-actions w-100 d-flex justify-content-between align-items-center">
    <div class="votum-modal__footer-left">
      @if (authService.isAdmin()) {
      <button class="btn btn-sm btn-warning votum-modal__regenerate-btn" (click)="regenerateVotum()"
        [disabled]="isRegenerating">
        @if (isRegenerating) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <span class="d-none d-sm-inline">Generiere neu...</span>
        } @else {
        <i class="bi bi-arrow-clockwise"></i>
        <span class="d-none d-sm-inline ms-1">Neu generieren</span>
        }
      </button>
      }
    </div>

    <div class="votum-modal__footer-right">
      <button type="button" class="btn btn-sm btn-secondary votum-modal__close-btn" (click)="close()">
        <i class="bi bi-x-lg d-sm-none"></i>
        <span class="d-none d-sm-inline">Schließen</span>
      </button>
    </div>
  </div>
</div>